import React from "react";
import { useLayoutEffect, useState } from "react";
import { useAxios } from "../hooks/axios";
import { Layout } from "../components/Layout";
import ProductList from "../components/ProductList";

interface SetupPageProps {
  // Add any props you need for the SetupPage component
}

export const SetupProductPage: React.FC<SetupPageProps> = () => {
  const [pageLoading, setpageLoading] = useState(true);
  const [isPinWrong, setIsPinWrong] = useState(false);
  const { loading, error, request } = useAxios();

  const veriftySetupPage = async () => {
    let pin: string = "";
    if (!localStorage.getItem("setup-pin")) {
      pin = window.prompt("Please enter your pin") || "";
      localStorage.setItem("setup-pin", pin);
    }

    try {
      const veriftyPin = localStorage.getItem("setup-pin") || "";
      const response = await request({
        url: "/veriftySetupPage",
        method: "POST",
        data: {
          pin: veriftyPin,
        },
      });
      if (response) {
        setIsPinWrong(false);
      }
    } catch (error) {
      setIsPinWrong(true);
      localStorage.removeItem("setup-pin");
    }

    setpageLoading(false);
  };

  useLayoutEffect(() => {
    veriftySetupPage();
  }, []);

  // Add your component logic here

  return (
    <Layout title="Setup Product">
      <div className="mt-3 register-div w-100 d-flex flex-column justify-content-center align-items-center">
        {pageLoading}
        {isPinWrong && !pageLoading && <div>401: Unauthorized</div>}
        {!isPinWrong && !pageLoading && <ProductList />}
      </div>
    </Layout>
  );
};
